import {hostName} from "../endpoint";
import {defaultHeaders} from "../headers";

export const resetClientPassword = async (password, token) => {
  try {
    const result = await fetch(`${hostName}/client/update-password`, {
      method: "POST",
      headers: defaultHeaders,
      body: JSON.stringify({password, token}),
    });
    const response = await result.json();
    return response.isSuccessful;
  } catch (err) {
    return false;
  }
};
